export default __webpack_public_path__ + "static/media/03.8ac21096.png";